module.exports = __webpack_public_path__ + "static/img/zhuanli-4.7aecb616.png";